<template>
  <div class="forma-pgto">
    <div v-if="!opcoesPagamentos" class="forma-pgto__loading">
      <svg width="20" height="20" viewBox="0 0 50 50" class="forma-pgto__loading-icon">
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="currentColor"
          stroke-width="5"
          stroke-linecap="round"
          stroke-dasharray="31.4 31.4"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
      Carregando formas de pagamento...
    </div>

    <div v-else-if="opcoesPagamentos.length === 0" class="forma-pgto__loading">
      Nenhuma forma de pagamento disponível para o valor atual do orçamento.
    </div>

    <div v-else-if="opcoesPagamentos.length > 0" class="forma-pgto__grid">
      <div class="forma-pgto__fields">
        <div class="forma-pgto__field">
          <label class="forma-pgto__label" for="selectPagamento">
            <i class="fa fa-credit-card"></i>
            Forma de Pagamento <span class="forma-pgto__required">*</span>
          </label>
          <select
            class="forma-pgto__select form-control"
            id="selectPagamento"
            v-model="formaPgto"
            :disabled="!orcamentoModoEdicao"
            @change="atualizarFormaPagamento()"
          >
            <option :value="null" disabled>Selecione uma opção</option>
            <option
              v-for="opcaoPgto in opcoesPagamentos"
              :key="opcaoPgto.id_forma"
              :value="opcaoPgto.id_forma"
            >
              {{ opcaoPgto.nome }}
            </option>
          </select>
        </div>

        <div class="forma-pgto__field" v-if="permiteMostrarParcelamento()">
          <label class="forma-pgto__label" for="selectPrazo">
            <i class="fa fa-calendar"></i>
            Prazo <span class="forma-pgto__required">*</span>
          </label>
          <select
            class="forma-pgto__select form-control"
            id="selectPrazo"
            v-model="condicaoPgto"
            :disabled="!orcamentoModoEdicao"
            @change="atualizarCondicaoPagamento()"
          >
            <option :value="null" disabled>Selecione uma opção</option>
            <option
              v-for="condicao in listarCondicoesParcelamento()"
              :key="condicao.id_condicao"
              :value="condicao.id_condicao"
            >
              {{ retornarDescricaoCondicaoPgto(condicao) }}
            </option>
          </select>
        </div>

        <div class="forma-pgto__pix" v-if="permiteMostrarPix()">
          <img
            src="https://www.deboravenancio.com.br/wp-content/uploads/2022/02/qrcode_chrome.png"
            alt="Imagem de qrcode"
            width="200"
          />
        </div>
      </div>

      <div class="forma-pgto__field forma-pgto__field--obs">
        <label class="forma-pgto__label" for="textareaObservacao">
          <i class="fa fa-flag"></i>
          Observação
        </label>
        <div class="forma-pgto__textarea-wrap">
          <textarea
            class="forma-pgto__textarea"
            id="textareaObservacao"
            rows="4"
            maxlength="300"
            placeholder="Adicione observações relevantes ao pedido..."
            :disabled="!orcamentoModoEdicao"
            v-model="obs"
            @keyup="charCount()"
            @blur="atualizarObservacao()"
          ></textarea>
          <span class="forma-pgto__counter">{{ charResult }} restantes</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.forma-pgto {
  width: 100%;
}

.forma-pgto__loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #8a94a6;
  font-weight: 600;
  padding: 0.5rem 0;
}

.forma-pgto__loading-icon {
  flex-shrink: 0;
}

.forma-pgto__grid {
  display: grid;
  grid-template-columns: minmax(220px, 0.95fr) minmax(280px, 1.45fr);
  gap: 1.25rem 1.5rem;
}

.forma-pgto__fields {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
}

.forma-pgto__field {
  min-width: 0;
}

.forma-pgto__label {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.55rem;
  color: #1f2a37;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.2;
}

.forma-pgto__label i {
  color: #0075eb;
  font-size: 0.9rem;
}

.forma-pgto__required {
  color: #e53935;
  font-weight: 700;
}

.forma-pgto__select {
  height: 44px;
  border: 1px solid #d8dee6;
  border-radius: 10px;
  background: #fff;
  color: #23282c;
  font-size: 0.92rem;
  font-weight: 500;
  box-shadow: none;
}

.forma-pgto__select:focus {
  border-color: #0075eb;
  box-shadow: 0 0 0 0.15rem rgba(0, 117, 235, 0.15);
}

.forma-pgto__textarea-wrap {
  position: relative;
}

.forma-pgto__textarea {
  display: block;
  width: 100%;
  min-height: 110px;
  padding: 0.75rem 0.9rem 1.7rem;
  border: 1px solid #d8dee6;
  border-radius: 10px;
  background: #fff;
  color: #23282c;
  font-size: 0.92rem;
  line-height: 1.45;
  resize: vertical;
  box-shadow: none;
}

.forma-pgto__textarea:focus {
  outline: none;
  border-color: #0075eb;
  box-shadow: 0 0 0 0.15rem rgba(0, 117, 235, 0.15);
}

.forma-pgto__textarea:disabled,
.forma-pgto__select:disabled {
  background: #f5f7fa;
  color: #8a94a6;
}

.forma-pgto__counter {
  position: absolute;
  right: 0.85rem;
  bottom: 0.55rem;
  color: #8a94a6;
  font-size: 0.75rem;
  font-weight: 500;
  pointer-events: none;
}

.forma-pgto__pix {
  margin-top: 0.25rem;
}

@media (max-width: 767.98px) {
  .forma-pgto__grid {
    grid-template-columns: 1fr;
  }
}
</style>

<script>
import Orcamento from "../../services/orcamento";
import { EventBus } from "../../helpers/eventBus";
import GrupoPermissao from "../../services/grupoPermissao";

export default {
  name: "FormaPgto",
  props: {
    orcamentoModoEdicao: Boolean,
    opcoesPagamentosIniciais: {
      type: [Object, Array],
      default: null
    },
    valorTotal: {
      type: Number,
      default: null
    }
  },
  data: () => {
    return {
      opcoesPagamentos: null,
      listaOpcoesPagamentos: [],
      formaPgto: null,
      condicaoPgto: null,
      charResult: 300,
      disabled: false,
      obs: ""
    };
  },
  beforeMount() {
    this.validaPermissao();
    this.orcamento_id = this.$route.params.id;
  },
  mounted() {
    EventBus.$on("eventoAtualizarPagamento", this.atualizarPagamento);
    this.obs = this.$store.state.orcamento.dados.observacao;
    this.formaPgto = this.$store.state.orcamento.dados.id_forma;
    this.condicaoPgto = this.$store.state.orcamento.dados.id_condicao;
    if (this.opcoesPagamentosIniciais != null) {
      this.aplicarOpcoesPagamentos(this.opcoesPagamentosIniciais);
    } else {
      this.buscarOpcoesPagamento();
    }
    this.charCount();
  },
  watch: {
    opcoesPagamentosIniciais(novasOpcoes) {
      if (novasOpcoes != null) {
        this.aplicarOpcoesPagamentos(novasOpcoes);
      }
    },
    valorTotal() {
      if (this.listaOpcoesPagamentos.length > 0) {
        this.atualizarPagamento();
      }
    }
  },
  methods: {
    validaPermissao() {
      GrupoPermissao.getPermissao("/vendas/orcamentos").then((response) => {
        if (!response.data.data) this.$router.push("/");
        else this.disabled = response.data.data.edita != "1";
      });
    },
    charCount() {
      this.charResult = 300 - (this.obs ? this.obs.length : 0);
    },
    parseValorNumerico(valor) {
      if (typeof valor === "number") {
        return Number.isFinite(valor) ? valor : NaN;
      }
      if (valor == null || valor === "") {
        return NaN;
      }
      const texto = String(valor).trim();
      if (texto.indexOf(",") !== -1) {
        return parseFloat(texto.replace(/\./g, "").replace(",", "."));
      }
      return parseFloat(texto);
    },
    obterValorTotal() {
      const doProp = this.parseValorNumerico(this.valorTotal);
      if (Number.isFinite(doProp)) {
        return doProp;
      }
      const doStore = this.parseValorNumerico(this.$store.state.orcamento.valorTotal);
      return Number.isFinite(doStore) ? doStore : 0;
    },
    normalizarListaOpcoes(opcoes) {
      if (Array.isArray(opcoes)) {
        return opcoes;
      }
      if (opcoes && typeof opcoes === "object") {
        return Object.keys(opcoes).map((chave) => opcoes[chave]);
      }
      return [];
    },
    aplicarOpcoesPagamentos(opcoes) {
      this.listaOpcoesPagamentos = this.normalizarListaOpcoes(opcoes);
      this.atualizarPagamento();
    },
    buscarOpcoesPagamento() {
      this.listaOpcoesPagamentos = [];
      this.opcoesPagamentos = null;

      Orcamento.buscarOpcoesPagamento(this.$store.state.orcamento.dados.pessoaFisica)
        .then(response => {
          let listaPagamentoFiltrada = response.data.data;
          this.listaOpcoesPagamentos = listaPagamentoFiltrada || [];
          this.atualizarPagamento();
        })
        .catch(error => {
          console.error(error);
          this.opcoesPagamentos = [];
          this.$helper.showErrorResponse(error);
        });
    },
    retornarDescricaoCondicaoPgto(condicaoPgto) {
      let descricaoParcela = condicaoPgto.qt_parcela > 1 ? "parcelas" : "parcela";
      let intervalo = String(condicaoPgto.intervalo).split(",").join("/");
      return `${condicaoPgto.qt_parcela} ${descricaoParcela} (${intervalo} dias) `;
    },
    atualizarFormaPagamento() {
      this.$store.commit("orcamento/SALVAR_DADO_ORCAMENTO", { id_forma: this.formaPgto });
      this.condicaoPgto = null;

      this.atualizarCondicaoPagamento();
    },
    atualizarCondicaoPagamento() {
      if (!this.permiteMostrarParcelamento() && !this.condicaoPgto && this.formaPgto) {
        let index = this.opcoesPagamentos.findIndex(el => el.id_forma == this.formaPgto);
        if (index != -1 && this.opcoesPagamentos[index].condicoes.length > 0) {
          this.condicaoPgto = this.opcoesPagamentos[index].condicoes[0].id_condicao;
        }
      }

      this.$store.commit("orcamento/SALVAR_DADO_ORCAMENTO", { id_condicao: this.condicaoPgto });
    },
    atualizarObservacao() {
      this.$store.commit("orcamento/SALVAR_DADO_ORCAMENTO", { observacao: this.obs });
    },
    atualizarPagamento() {
      this.carregarPagamento();

      if (!Array.isArray(this.opcoesPagamentos) || this.opcoesPagamentos.length === 0) {
        return;
      }

      if (this.formaPgto) {
        let index = this.opcoesPagamentos.findIndex(el => el.id_forma == this.formaPgto);

        if (index == -1) {
          this.formaPgto = null;
          this.condicaoPgto = null;
          this.atualizarFormaPagamento();
        }
      }

      if (this.condicaoPgto) {
        let indexFormaPgto = this.opcoesPagamentos.findIndex(el => el.id_forma == this.formaPgto);
        if (indexFormaPgto == -1) {
          this.condicaoPgto = null;
          this.atualizarCondicaoPagamento();
          return;
        }

        let indexCondicao = this.opcoesPagamentos[indexFormaPgto].condicoes.findIndex(
          el => el.id_condicao == this.condicaoPgto
        );

        if (indexCondicao == -1) {
          this.condicaoPgto = null;
          this.atualizarCondicaoPagamento();
        }
      }
    },
    carregarPagamento() {
      let listapagamentos = [];
      const valorTotal = this.obterValorTotal();

      if (!Array.isArray(this.listaOpcoesPagamentos) || this.listaOpcoesPagamentos.length == 0) {
        this.opcoesPagamentos = [];
        return;
      }

      for (let i = 0; i < this.listaOpcoesPagamentos.length; i++) {
        const forma = this.listaOpcoesPagamentos[i];
        const condicoesForma = Array.isArray(forma.condicoes) ? forma.condicoes : [];
        let condicaoValida = false;
        let listaCondicoes = [];
        let temParcelamento = false;
        let ehPix = false;

        for (let j = 0; j < condicoesForma.length; j++) {
          const condicao = condicoesForma[j];
          let vlMinimo = this.parseValorNumerico(condicao.vl_minimo);
          let vlMaximo = this.parseValorNumerico(condicao.vl_maximo);

          if (!Number.isFinite(vlMinimo)) {
            vlMinimo = 0;
          }
          if (!Number.isFinite(vlMaximo)) {
            vlMaximo = Number.MAX_SAFE_INTEGER;
          }

          if (vlMinimo <= valorTotal && vlMaximo >= valorTotal) {
            condicaoValida = true;
            listaCondicoes.push(condicao);

            if (condicao.intervalo != 0) {
              temParcelamento = true;
            }

            if (condicao.intervalo == 0 && forma.nome == "Pix") {
              ehPix = true;
            }
          }
        }

        if (condicaoValida) {
          listapagamentos.push({
            id_forma: forma.id_forma,
            nome: forma.nome,
            condicoes: listaCondicoes,
            temParcelamento: temParcelamento,
            ehPix: ehPix
          });
        }
      }
      this.opcoesPagamentos = listapagamentos;
    }
  },
  computed: {
    permiteMostrarParcelamento() {
      return () => {
        if (!this.formaPgto || !Array.isArray(this.opcoesPagamentos)) {
          return false;
        }

        let index = this.opcoesPagamentos.findIndex(el => el.id_forma == this.formaPgto);
        if (index == -1) {
          return false;
        }

        return this.opcoesPagamentos[index].temParcelamento;
      };
    },
    permiteMostrarPix() {
      return () => {
        if (!this.formaPgto || !Array.isArray(this.opcoesPagamentos)) {
          return false;
        }

        let index = this.opcoesPagamentos.findIndex(el => el.id_forma == this.formaPgto);
        if (index == -1) {
          return false;
        }

        return this.opcoesPagamentos[index].ehPix && !this.orcamentoModoEdicao;
      };
    },
    listarCondicoesParcelamento() {
      return () => {
        let index = this.opcoesPagamentos.findIndex(el => el.id_forma == this.formaPgto);
        if (index == -1) {
          return [];
        }

        return this.opcoesPagamentos[index].condicoes;
      };
    }
  },
  beforeDestroy() {
    EventBus.$off("eventoAtualizarPagamento", this.atualizarPagamento);
  }
};
</script>
